/*
  Таблица домов портфеля: адрес, участок, число счетов и сумма требований.

  🔴 Указание владельца 14.09.2026: показывать ВЕСЬ портфель, а не только дома,
  заведённые в справочнике. Дом, которого нет в списке, - это дом, по которому
  никто не начнёт работу.

  Дом без участка помечен словами, а не оставлен пустой клеткой: пустая клетка
  читается как «данные потеряли», а означает ровно обратное - работу, которую
  никто не сделал. Заявление по счетам такого дома не сформируется вовсе.
*/

import { money } from '../api/format.js'
import { Empty, Tag } from './Common.jsx'
import PageBar from './PageBar.jsx'

export default function HouseTable({ houses, bar, selected, onSelect }) {
  // 21.10.2026: у управляющей компании домов сотни - страницы режет сервер, под
  // таблицей общая панель. `houses` - строки текущей страницы, `bar` - свойства панели.
  // Выбранный дом хранится в родителе и от страницы не зависит.
  if (houses.length === 0) {
    return (
      <Empty title="Домов пока нет">
        Дома появятся здесь после первой загрузки выгрузки биллинга: Арбитр ЖКХ берёт их из адресов
        помещений.
      </Empty>
    )
  }

  return (
    <>
      <table className="table table--fixed table--houses">
        <thead>
          <tr>
            <th>Дом</th>
            <th>Судебный участок</th>
            <th className="table__num">Счетов</th>
            <th className="table__num">К взысканию</th>
          </tr>
        </thead>
        <tbody>
          {houses.map((house) => (
            <tr
              key={house.address}
              className={house.address === selected ? 'row--selected' : undefined}
            >
              {/* Первая ячейка подписи не носит: адрес читается сам и служит
                  заголовком карточки на узком экране (правило 6е). */}
              <td>
                <button className="link-button" type="button" onClick={() => onSelect(house.address)}>
                  {house.address}
                </button>
              </td>
              <td className="table__block" data-label="Судебный участок">
                {/* С 02.11.2026 участок дому находит и общий справочник: дом без своей
                    записи участок имеет, а запись без участка - не всегда. Решает
                    наличие участка, а не записи; откуда он взят, не показывается. */}
                {house.section_name ? (
                  <>№ {house.section_number} - {house.section_name}</>
                ) : (
                  <Tag kind="warn">участок не определён</Tag>
                )}
              </td>
              <td className="table__num" data-label="Счетов">
                {house.accounts_count}
              </td>
              <td className="table__num" data-label="К взысканию">
                {money(house.claim_amount)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <PageBar {...bar} what="домов" />
    </>
  )
}
